// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ixEx","right":"styles_right__VA_IU"};